// extracted by mini-css-extract-plugin
export default {"header":"MainLayout_header__-J2BZ","left":"MainLayout_left__edwzJ","right":"MainLayout_right__xoA-T","main":"MainLayout_main__XDITe","footer":"MainLayout_footer__tIOmz"};